import { Typography } from "@mui/material";
import { sxGreenBody, sxGreenSubTitle } from "../../../../../assets/styles/CommonSxProps";
import { formatStringToReaisNumberFormat } from "../../../../../utils/MoneyFormat";
import "./styles.css";

const ValorTotalReembolso: React.FC<{ valor: string, qtdItens: number }> = ({ valor, qtdItens }) => {

  return (
    <div className={`procedimento-reembolso-card ${qtdItens % 2 === 0 ? 'even' : 'odd'} radius-vlr-total`}>
      <div className="valor-row">
        <Typography sx={sxGreenSubTitle}>Valor total</Typography>
        <Typography sx={sxGreenBody}>R$ {`${formatStringToReaisNumberFormat(valor)}`}</Typography>
      </div>
    </div>
  )
}

export default ValorTotalReembolso;